import React from 'react';
import VideoItem from '../../shared/components/VideoItem';
import { StyleSheet, css } from 'aphrodite/no-important';
import {constants} from '../constants';

const cssMediaItemSettings = {
	desktop: { item: { width: '360px' }},
	laptop: { item: { width: '300px' }},
	tablet: { item: { width: '347px' }},
	mobile: { item: { width: '46%' }}
};

class SixItems extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const posts = this.props.posts.slice(0, 6);
		let outerIndex = 0;
		let utmObj = this.props.utmObj || {};
		let key = 1;

		return (
			<div className={css(this.props.containerStyle)}>
				{posts.map(p => (<VideoItem post={p} key={key++} mediaSettings={cssMediaItemSettings} outerIndex={outerIndex++} utmObj={utmObj} classPostfix={constants.VC_CLASS_POSTFIX} />))}
			</div>
		);
	}
}

export default SixItems;



// WEBPACK FOOTER //
// ./react-app-src/videoCollections/components/SixItems.js